export const INITIALNOTIFICATION_LIST = "INITIALNOTIFICATION_LIST";
export const RESET_INITIALNOTIFICATION_LIST = "RESET_INITIALNOTIFICATION_LIST";
export const LOADMORENOTIFICATION_LIST = "LOADMORENOTIFICATION_LIST";
export const DEDUCTNOTIFICATION_COUNT = "DEDUCTNOTIFICATION_COUNT";
export const DEDUCT_MAIL_NOTIFICATION_COUNT = "DEDUCT_MAIL_NOTIFICATION_COUNT";
export const INITIAL_NOTIFICATION_READ = "INITIAL_NOTIFICATION_READ";
export const LOADMORE_NOTIFICATION_READ = "LOADMORE_NOTIFICATION_READ";
